document.addEventListener('DOMContentLoaded', function() {
  const fraganceMeter = document.getElementById('fragance-meter');
  const intensityLevels = document.querySelectorAll('.intensity-level');

  function updateFraganceMeter(intensity) {
    if (intensity === 6) {
      // Mostrar todas las barras, pero sin colorearlas
      fraganceMeter.style.display = 'block';
      intensityLevels.forEach(level => level.classList.remove('checkint'));
    } else if (intensity > 0) {
      // Mostrar y colorear las barras hasta la intensidad
      fraganceMeter.style.display = 'block';
      intensityLevels.forEach(level => level.classList.remove('checkint'));
      intensityLevels.forEach((level, index) => {
        if (index + 1 <= intensity) {
          level.classList.add('checkint');
        }
      });
    } else {
      // Ocultar el medidor si la intensidad es 0
      fraganceMeter.style.display = 'none';
    }
  }

  const variantIdInput = document.querySelector('.dynamic-variant-id');
  if (variantIdInput) {
  variantIdInput.addEventListener('change', function() {
    const selectedVariantId = variantIdInput.value;
    const selectedVariant = window.variants.find(variant => variant.id == selectedVariantId);
    
    if (selectedVariant) {
      const intensity = parseInt(selectedVariant.intensidad, 10);
        updateFraganceMeter(intensity);
      }
    });
  }
});
